import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "../styles/NotFound.css";

const NotFound: React.FC = () => {
  return (
    <div className="not-found-container">
      <motion.div
        className="not-found-content"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <motion.h1
          className="not-found-404"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{
            type: "spring",
            stiffness: 260,
            damping: 20,
            delay: 0.2,
          }}
        >
          404
        </motion.h1>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <h2 className="not-found-title">Page Not Found</h2>
          <p className="not-found-message">
            Oops! The page you're looking for seems to have wandered off into
            the digital void.
          </p>
        </motion.div>

        <motion.div
          className="not-found-links"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          <Link to="/" className="not-found-home-link">
            <motion.button
              className="not-found-button"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Go Home
            </motion.button>
          </Link>
        </motion.div>

        <motion.div
          className="not-found-decoration"
          animate={{
            rotate: 360,
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: "linear",
          }}
        >
          <div className="orbit-ring"></div>
          <div className="orbit-dot"></div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default NotFound;
